import { Component, Injector, Input, OnInit } from '@angular/core';
import { StripeInfosService } from '@services/entity/stripe-infos.service';
import { plainToClass } from 'class-transformer';
import { UsersService } from '@services/entity/users.service';
import { InvoiceDto } from '@dto/invoiceDto';
import { InvoicesService } from '@services/entity/invoices.service';
import { UserDto } from '@dto/userDto';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { CustomersService } from '@services/entity/customers.service';
import { PayoutStatementsService } from '@services/entity/payout-statements.service';
import { ToastService } from '@services/toast/toast.service';
import { CurrencyPipe } from '@angular/common';
import { PayoutAmountDue } from '@dto/payoutAmountDue';

@Component({
  selector: 'payout-preview',
  templateUrl: './payout-preview.component.html',
  styleUrls: ['./payout-preview.component.scss'],
})
export class PayoutPreviewComponent implements OnInit {

  public className = 'PayoutPreviewComponent'

  public user: UserDto

  public isLoading: boolean = true
  public isOperator: boolean = false
  public isCustomer: boolean = false
  public isUser: boolean = false
  public isSupporter: boolean = false;
  
  @Input() customerUserId?: string
  public scheduledPayoutDate: Date
  public amountDue: PayoutAmountDue
  
  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public toastService: ToastService,
    public usersService: UsersService,
    public customersService: CustomersService,
    public authenticationService: AuthenticationService,
    public payoutStatementsService: PayoutStatementsService,
    public stripeInfosService: StripeInfosService,
    injector: Injector
  ) {
    this.router = injector.get(Router);
  }

  ngOnInit(): void {
    this.getUser();
    this.getRoles();
    this.setScheduledPayoutDate();
    this.getPayoutAmountDue();

    this.isLoading = false;
  }

  setScheduledPayoutDate(): void {
    const now = new Date()
    let date: number = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
    
    if (now.getDate() > 2) {
      date = Date.UTC(now.getFullYear(), now.getMonth() + 1, now.getDate(), 0, 0, 0, 0);
    }

    this.scheduledPayoutDate = new Date(date);
  }

  getUser() {
    this.usersService.getLoggedInUser().subscribe(user => {
      this.user = plainToClass(UserDto, user);
    })
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;
    if (this.authenticationService.userHasRole('Customer')) this.isCustomer = true;
    if (this.authenticationService.userHasRole('User')) this.isUser = true;
    this.isSupporter = this.authenticationService.userHasRole('Supporter')
  }

  isDate(value: string) {
    if (!value || typeof value != 'string') return false;
    return new RegExp(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z*/).test(value.trim());
  }

  parseDate(date: Date) {
    if (!date) return false;
    const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    return months[new Date(date).getMonth()];
  }

  getPayoutAmountDue() {
    this.payoutStatementsService.getPayoutAmountDue(this.customerUserId).subscribe(amountDue => {
      if (amountDue != null) {
        this.amountDue = amountDue;
      }
    }, error => {
      console.error(error)
    })
  }

  payout() {
    if (!this.customerUserId) {
      this.toastService.error($localize`:@@UserIsMissingCustomerId:Es fehlt die Customer ID des Benutzers.`);
      return;
    }
    
    this.payoutStatementsService.payout(this.customerUserId).subscribe(amount => {
      if (amount != null) {
        var cash = new CurrencyPipe('de-DE', 'EUR').transform(amount / 100);
        this.toastService.success($localize`:@@PayoutSuccessful:Auszahlung über ${cash} erfolgreich ausgelöst. Die Überweisung kann ein bis zwei Werktage dauern.`);
        this.getPayoutAmountDue();
      }
    }, error => {
      if (error.includes('Amount must be no less than')) {
        this.toastService.error($localize`:@@PayoutFailed:Der Auszahlungsbetrag muss mindestens 1,00 € betragen.`);
      } else {
        this.toastService.error($localize`:@@PayoutFailed:Die Auszahlung ist fehlgeschlagen.`);
      }
      console.error(error)
    })
  }

  matches(entity: InvoiceDto, term: string) {
    return InvoicesService.matches(entity, term);
  }
}